import {Injectable} from '@angular/core';
import {RestangularModule, Restangular} from 'ngx-restangular'

@Injectable()
export class IncidentTypeService {

    constructor(private restangular:Restangular) {
    }

    getIncidentFormData() {
        return this.restangular.one('getIncidentFormData');
    }

    getAllIncidentTypes() {
        return this.restangular.all('getAllIncidentTypes');
    }

    incidentTypesCRUD() {
        return this.restangular.all('incidentTypesCRUD');
    }

    incidentTypeUD(id) {
        return this.restangular.one('incidentTypesCRUD/' + id);
    }

    removeIncidentType() {
        return this.restangular.all('removeIncidentType');
    }

    getTypeheadEmployees() {
        return this.restangular.one('getTypeheadEmployees');
    }


}



// WEBPACK FOOTER //
// /app/src/app/services/incident-type.service.ts